/**
 * 活动管理
 */
import { ACTIVITYLIST } from '../types';

export default {
    name: `${ACTIVITYLIST}`,
    path: '/activityList',
    component: () => import(/* webpackChunkName: 'activityList' */ '@/views/activityList/'),
    redirect: { name: `${ACTIVITYLIST}Index` },
    meta: {
        title: '活动管理',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${ACTIVITYLIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'activityListIndex' */ '@/views/activityList/home/Home.vue'),
        },

        {
            name: `${ACTIVITYLIST}Create`,
            path: 'create',
            component: () => import(/* webpackChunkName: 'activityListCreate' */ '@/views/activityList/create/Create.vue'),
        },
        {
            name: `${ACTIVITYLIST}Edit`,
            path: 'edit/:id',
            component: () => import(/* webpackChunkName: 'activityListEdit' */ '@/views/activityList/create/Create.vue'),
        },
        {
            name: `${ACTIVITYLIST}Scope`,
            path: 'scope/:id',
            component: () => import(/* webpackChunkName: 'activityListScope' */ '@/views/activityList/scope/Scope.vue'),
        },
        {
            name: `${ACTIVITYLIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'activityListDetail' */ '@/views/activityList/detail/Detail.vue'),
        },
    ],
};
